@if(!!contactInformation){
<vy-box [boxLevel]="boxLevelEnum.LEVEL_TWO">
  <ng-container box-content>
    @if(contactInformation.firstName){
    <vy-avatar-name
      [avatarInput]="{title: { firstLetter: contactInformation.firstName, secondLetter: contactInformation.surname }}"
    ></vy-avatar-name>
    } @if(contactInformation.agencyName) {<span class="bodyS agent_data_text marginRight-m"
      ><strong>{{'booking_details_component.contact_information_component.agent' | translate}}</strong>
      {{contactInformation.agencyName}}</span
    >}
    <span class="bodyS agent_data_text marginRight-m"
      ><strong>{{'booking_details_component.contact_information_component.telephone' | translate}}</strong>
      {{contactInformation.phoneNumber}}</span
    ><span class="bodyS agent_data_text"
      ><strong>{{'booking_details_component.contact_information_component.email' | translate}}</strong>
      {{contactInformation.contactMail}}</span
    >
  </ng-container>
</vy-box>
}
